import React, { Component } from 'react';
import axios from 'axios';
import $ from 'jquery';
import Cookies from 'universal-cookie';
import ReactEmoji from 'react-emoji';
import {emojify} from 'react-emojione';
import URL from '../../flux/path';
import {siv} from '../../flux/siv';
import {
	ShareButtons,
	ShareCounts,
	generateShareIcon
  } from 'react-share';

  const {
	FacebookShareButton,
	GooglePlusShareButton,
	LinkedinShareButton,
	TwitterShareButton,
	TelegramShareButton,
	WhatsappShareButton,
	PinterestShareButton,
	VKShareButton,
	OKShareButton,
	RedditShareButton,
	TumblrShareButton,
	EmailShareButton,
  } = ShareButtons;
const options = {
		convertShortnames: false,
		convertUnicode: true,
		convertAscii: true,
		output: 'unicode'
	};
export default class Teams extends Component{
	constructor(props){
		super(props);
		this.state = { temaSlug: this.props.match.params.pathParam, temaID: [], temas: [], temaContent: [] }
		$('body').css('margin-bottom', '0');
	}
	componentWillMount(){
		$('body').css('margin-bottom', '0');
		$('#identifier li a').on('click', function(){
			alert('in');
		});
		$(document).on('click', '.theme-item', function(e){
			var $this = $(this);
			var $href = $( $this.attr('href') );
			var $top = $('.post-body-wrap')[0].scrollTop;
			$('.post-body-wrap').animate( { scrollTop: $top + $( $this.attr('href') ).position().top-30 }, 500 );
			$( $href )[0].scrollIntoView(true);
			e.preventDefault();
		});
		this.getTemaContent( this.state.temaSlug );
	}
	componentDidMount(){
		$('body').css('margin-bottom', '0');
		$(document).on('click', '.list-like' ,function(e){
			e.preventDefault();
		})
	}
	getTemaContent( id ){
		axios.get( URL.temas + '?slug=' + id )
		.then( res => {
			this.setState({ temaID: res.data[0].id });
			this.setState({ temaSlug: this.props.match.params.pathParam });
			this.setState({ temaContent: res.data[0] });
			this.getTemasMundoON( res.data[0].id );
		});
	}

	getTemasMundoON( ID ){
		axios.get( URL.mundo_on + '?filter[meta_query][0][key]=tema&filter[meta_query][0][value]=' + ID )
		.then( res => {
			this.setState({ temas: res.data });
		});
	}
	setLike( id, slug ){
		// CREATING COOKIE;
		const cookies = new Cookies();
		const check_cookie_id = cookies.get( `${slug}_${id}` );
		// SET DATE FOR EXPIRE
		var $date = 3600 * 1000 * 24 * 365 * 10;
		// CHECKING COUNTERS;
		var counterLike = $('#likeC-' + id).text();
		var counterNeutral = $('#neutralC-' + id).text();
		var counterNegative = $('#sadC-' + id).text();
		// CHECK IF COOKIE EXISTS
		if( !check_cookie_id ){
			cookies.set( `${slug}_${id}`, 'liked', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.likes_cb}&post_id=${id}` );
			$('#like-' + id).addClass('is-selected');
			counterLike++;
			$('#likeC-' + id).text( counterLike );
		// CHECK IF COOKIE IS NEUTRAL	
		} else if( check_cookie_id === 'neutral' ){
			cookies.set( `${slug}_${id}`, 'liked', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.likes_cb}&post_id=${id}` );
			axios.post( `${URL.ajax}${URL.neutral_cb}&post_id=${id}&cookie=true` );
			$('#like-' + id).addClass('is-selected');
			counterLike++;
			$('#likeC-' + id).text( counterLike );
			$('#neutral-' + id).removeClass('is-selected');
			counterNeutral--;
			$('#neutralC-' + id).text( counterNeutral );
		// CHECK IF COOKIE IS NEGATIVE
		} else if ( check_cookie_id === 'negative' ){
			cookies.set( `${slug}_${id}`, 'liked', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.likes_cb}&post_id=${id}` );
			axios.post( `${URL.ajax}${URL.negative_cb}&post_id=${id}&cookie=true` );
			$('#like-' + id).addClass('is-selected');
			counterLike++;
			$('#likeC-' + id).text( counterLike );
			$('#sad-' + id).removeClass('is-selected');
			counterNegative--;
			$('#sadC-' + id).text( counterNegative );
		// REMOVE COOKIE
		} else {
			cookies.remove( `${slug}_${id}`, { path: '/' } );
			axios.post( `${URL.ajax}${URL.likes_cb}&post_id=${id}&cookie=true` );
			$('#like-' + id).removeClass('is-selected');
			counterLike--;
			$('#likeC-' + id).text( counterLike );
		}
		//window.location.reload();
	}

	setNeutral( id, slug ){
		const cookies = new Cookies();
		const check_cookie_id = cookies.get( `${slug}_${id}` );
		var $date = 3600 * 1000 * 24 * 365 * 10;
		var counterLike = $('#likeC-' + id).text();
		var counterNeutral = $('#neutralC-' + id).text();
		var counterNegative = $('#sadC-' + id).text();
		if( !check_cookie_id ){
			cookies.set( `${slug}_${id}`, 'neutral', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.neutral_cb}&post_id=${id}` );
			$('#neutral-' + id).addClass('is-selected');
			counterNeutral++;
			$('#neutralC-' + id).text( counterNeutral );
		} else if( check_cookie_id === 'liked' ){
			cookies.set( `${slug}_${id}`, 'neutral', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.neutral_cb}&post_id=${id}` );
			axios.post( `${URL.ajax}${URL.likes_cb}&post_id=${id}&cookie=true` );
			$('#neutral-' + id).addClass('is-selected');
			counterNeutral++;
			$('#neutralC-' + id).text( counterNeutral );
			$('#like-' + id).removeClass('is-selected');
			counterLike--;
			$('#likeC-' + id).text( counterLike );
		} else if ( check_cookie_id === 'negative' ){
			cookies.set( `${slug}_${id}`, 'neutral', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.neutral_cb}&post_id=${id}` );
			axios.post( `${URL.ajax}${URL.negative_cb}&post_id=${id}&cookie=true` );
			$('#neutral-' + id).addClass('is-selected');
			counterNeutral++;
			$('#neutralC-' + id).text( counterNeutral );
			$('#sad-' + id).removeClass('is-selected');
			counterNegative--;
			$('#sadC-' + id).text( counterNegative );
		} else {
			cookies.remove( `${slug}_${id}`, { path: '/' } );
			axios.post( `${URL.ajax}${URL.neutral_cb}&post_id=${id}&cookie=true` );
			$('#neutral-' + id).removeClass('is-selected');
			counterNeutral--;
			$('#neutralC-' + id).text( counterNeutral );
		}
		//window.location.reload();
	}
	setNegative( id, slug ){
		const cookies = new Cookies();
		const check_cookie_id = cookies.get( `${slug}_${id}` );
		var $date = 3600 * 1000 * 24 * 365 * 10;
		var counterLike = $('#likeC-' + id).text();
		var counterNeutral = $('#neutralC-' + id).text();
		var counterNegative = $('#sadC-' + id).text();
		if( !check_cookie_id ){
			cookies.set( `${slug}_${id}`, 'negative', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.negative_cb}&post_id=${id}` );
			$('#sad-' + id).addClass('is-selected');
			counterNegative++;
			$('#sadC-' + id).text( counterNegative );
		} else if( check_cookie_id === 'liked' ){
			cookies.set( `${slug}_${id}`, 'negative', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.negative_cb}&post_id=${id}` );
			axios.post( `${URL.ajax}${URL.likes_cb}&post_id=${id}&cookie=true` );
			$('#sad-' + id).addClass('is-selected');
			counterNegative++;
			$('#sadC-' + id).text( counterNegative );
			$('#like-' + id).removeClass('is-selected');
			counterLike--;
			$('#likeC-' + id).text( counterLike );
		} else if ( check_cookie_id === 'neutral' ){
			cookies.set( `${slug}_${id}`, 'negative', { path: '/', maxAge: $date } );
			axios.post( `${URL.ajax}${URL.negative_cb}&post_id=${id}` );
			axios.post( `${URL.ajax}${URL.neutral_cb}&post_id=${id}&cookie=true` );
			$('#sad-' + id).addClass('is-selected');
			counterNegative++;
			$('#sadC-' + id).text( counterNegative );
			$('#neutral-' + id).removeClass('is-selected');
			counterNeutral--;
			$('#neutralC-' + id).text( counterNeutral );
		} else {
			cookies.remove( `${slug}_${id}`, { path: '/' } );
			axios.post( `${URL.ajax}${URL.negative_cb}&post_id=${id}&cookie=true` );
			$('#neutral-' + id).removeClass('is-selected');
			counterNegative--;
			$('#neutralC-' + id).text( counterNegative );
		}
		//window.location.reload();
	}
	render(){
		if( this.state.temas == '' && this.state.temaContent == '' ){
			return <div />;
		}

		return (
			<div>
				<article>
					<section className="section-container post single">
						<div className="container-fluid h-100 relative">
							<div className={'section-fixed ' + this.props.match.params.pathParam}>
								<div className="content pt-5">
	
									<img src={this.state.temaContent.image_featured} alt={ this.state.temaContent.title.rendered } />
									<h1>
										{ this.state.temaContent.title.rendered }
									</h1>
									<ul className="list-theme-items hidden-xs-down">
										{
											this.state.temas.map(tema => {
												if(tema.tema_id == this.state.temaID){
													return (
													<div id="identifier" key={tema.id}>
														<li>
															<a className="theme-item" href={ '#' + tema.slug }>{tema.title.rendered}</a>
														</li>
													</div>
													)
												}
											})
										}
									</ul>
								</div>
							</div>
							<div className="row align-items-center h-100">
								<div className="col-18 col-xl-10 offset-xl-7 relative">
									<div className="post-body-container">
										<div className="post-body-wrap">
											<div className="post-header pt-5">
												<p className="excerpt"><div dangerouslySetInnerHTML={{ __html: this.state.temaContent.excerpt }} /></p>
												<div dangerouslySetInnerHTML={{ __html: this.state.temaContent.content.rendered }} />
											</div>
											<div className="post-body">
												<div className="item-exercise">
													{
														this.state.temas.map(tema => {
															if(tema.tema_id == this.state.temaID){
																const content = ReactEmoji.emojify(tema.content.rendered );
																const cookies = new Cookies();
																if( cookies.get( `${tema.slug}_${tema.id}` ) === 'liked' ){
																	setTimeout( function(){ $('#like-' + tema.id ).addClass('is-selected'); }, 200 );
																} else if ( cookies.get( `${tema.slug}_${tema.id}` ) === 'neutral' ) {
																	setTimeout( function(){ $('#neutral-' + tema.id ).addClass('is-selected'); }, 200 );
																} else if( cookies.get( `${tema.slug}_${tema.id}` ) === 'negative' ) {
																	setTimeout( function(){ $('#sad-' + tema.id ).addClass('is-selected'); }, 200 );
																}
																return (
																	<div key={tema.id}>
																		<div className="item-content">
																			<h2 id={tema.slug}><div dangerouslySetInnerHTML={{ __html: tema.title.rendered }} /></h2>
																			<div dangerouslySetInnerHTML={{ __html: content[0] }} />
																		</div>
																		<div className="item-share mt-5 mb-5">
																			<ul className="list-like">
																				<li><a id={ 'like-' + tema.id } href="#" onClick={() => this.setLike( tema.id, tema.slug )} className="icon-smile"></a><span id={ 'likeC-' + tema.id } className="counter">{tema.likes}</span></li>
																				<li><a id={ 'neutral-' + tema.id } href="#" onClick={() => this.setNeutral( tema.id, tema.slug )} className="icon-ok"></a><span id={ 'neutralC-' + tema.id } className="counter">{tema.neutral}</span></li>
																				<li><a id={ 'sad-' + tema.id } href="#" onClick={() => this.setNegative( tema.id, tema.slug )} className="icon-sad"></a><span id={ 'sadC-' + tema.id } className="counter">{tema.negative}</span></li>
																			</ul>
																			<label>partilhar</label>
																			<ul className="list-social">
																				<li>
																					<FacebookShareButton url={ 'https://decojovem.pt/iniciativa/mundon/' + this.props.match.params.pathParam } >
																						<a href="#" className="fa fa-facebook"></a>
																					</FacebookShareButton>
																				</li>
																				<li>
																					<TwitterShareButton url={ 'https://decojovem.pt/iniciativa/mundon/' + this.props.match.params.pathParam } >
																						<a href="#" className="fa fa-twitter"></a>
																					</TwitterShareButton>
																				</li>
																			</ul>
																		</div>
																	</div>
																)
															}
														})
													}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</section>
				</article>
				
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/temas/index.js